<div class="kanban-board">
    <div class="kanban-column" *ngFor="let column of shimmerColumns">
      <div class="shimmer-column-header"></div>
      <div class="kanban-card shimmer-card" *ngFor="let card of shimmerCards"></div>
    </div>
  </div>
  